import styled from 'styled-components';

export const ScoreWrapper = styled('span')`
  position: relative;
  display: inline-block;
  height: ${({ theme }) => theme.x3spacePx}px;
`;

export const MarkContainer = styled('div')`
  display: inline-block;
  cursor: pointer;
  margin-right: ${({ theme }) => theme.x1spacePx / 2}px;
`;

export const DescriptionWrapper = styled('div')`
  max-width: 280px;
  p {
    margin: 0;
  }
`;

export const Good = styled('span')`
  color: ${({ theme }) => theme.color.good};
`;

export const Bad = styled('span')`
  color: ${({ theme }) => theme.color.bad};
`;
